import { UseFormRegister } from 'react-hook-form';
import { RawFormFillerData } from 'shared-utils/types/formFiller';
import { StyledTextInput } from '../styles';
import { FieldState, getTabIndex } from '../../../lib/formFiller';
import { WithOptionalTooltip } from './WithOptionalTooltip';
import { useMemo } from 'react';
/**
 * Date input field component for PDF forms
 */
export function DateFieldInput({
  fieldState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dateFormat = 'YYYY-MM-DD',
  autoFilledDate,
  value,
  register,
}: {
  fieldState: FieldState;
  dateFormat: string;
  autoFilledDate: boolean;
  value: any;
  register: UseFormRegister<RawFormFillerData>;
}) {
  // TODO(sshader) use date-fns
  // Format value for date input (YYYY-MM-DD)
  const formatDateValue = (val: any) => {
    if (!val) return '';

    // If it's already in YYYY-MM-DD format, return as is
    if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return val;
    }

    // Try to parse and format the date
    try {
      const date = new Date(val);
      if (isNaN(date.getTime())) return '';

      return date.toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  const currentDate = useMemo(() => new Date().toISOString().split('T')[0], []);

  const isReadOnly = !!fieldState.isReadOnly || autoFilledDate;
  const valueToDisplay = autoFilledDate ? currentDate : value;

  return (
    <WithOptionalTooltip fieldState={fieldState} autoFilledDate={autoFilledDate}>
      <StyledTextInput
        // Treat auto-filled fields as disabled / unassigned since the signer can't interact with them
        $isUnassigned={!fieldState.isAssigned || autoFilledDate}
        $isEmpty={fieldState.isEmpty && !autoFilledDate}
        $isRequired={fieldState.isRequired && !autoFilledDate}
        $isReadOnly={isReadOnly}
        {...register(fieldState.id)}
        type="date"
        $fieldType="date"
        readOnly={isReadOnly}
        tabIndex={getTabIndex(fieldState)}
        value={formatDateValue(valueToDisplay)}
      />
    </WithOptionalTooltip>
  );
}
